import { render, staticRenderFns } from "./AltasCrmPantalla.vue?vue&type=template&id=0dc60848&"
import script from "./AltasCrmPantalla.vue?vue&type=script&lang=ts&"
export * from "./AltasCrmPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0dc60848', component.options)
    } else {
      api.reload('0dc60848', component.options)
    }
    module.hot.accept("./AltasCrmPantalla.vue?vue&type=template&id=0dc60848&", function () {
      api.rerender('0dc60848', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/AltasCrm/AltasCrmPantalla.vue"
export default component.exports